import React from 'react';
import ReactDOM from 'react-dom/client';
import { injectCssVars } from '@aseller/antd-theme/css';
import App from './App';
import VersionUpdateNotice from './VersionUpdateNotice';
import { STANDALONE_THEME_MODE } from '../shared/theme';
import './index.css';

// Переменные `--as-*` дизайн-системы для глобальных стилей: их читают index.css и
// css виджетов версии. Объявляются ЗДЕСЬ, а не в общем с ремоутом коде, потому что
// пишутся в documentElement — на странице платформы это был бы захват её :root.
// В embed эти стили и не нужны: всё, что их использует, живёт только в standalone
// (шапка, баннер обновления, changelog).
//
// До вызова render, иначе первый кадр отрисуется с пустыми переменными.
injectCssVars(STANDALONE_THEME_MODE);

// VersionUpdateNotice рендерится здесь, а не внутри App: он тянет свой глобальный
// .css, а App теперь общий с точкой входа ремоута, куда глобальным стилям нельзя.
// Баннер и по смыслу standalone-only — версию модуля на странице платформы
// обновляет хост, а не пользователь. Позиция в дереве на вёрстку не влияет:
// баннер position:fixed и до появления новой версии рендерит null.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <VersionUpdateNotice />
    <App />
  </React.StrictMode>,
);
